import { ChangeDetectionStrategy, Component, inject, output, signal } from "@angular/core";

import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";

import { LktIconComponent } from "../icon/icon.component";

import { ProfileSelectionItem } from "./profile-selection-item.interface";

export interface ProfileSelectionModalData {
  profiles: ProfileSelectionItem[];
  // Título do modal; default "Seleção de perfil" (login usa "Seleção de perfil do login").
  title?: string;
  /** Nome acessível do ×; default "Fechar" (login usa "Voltar para o Login"). */
  closeLabel?: string;
  onProfileSelected?: (profile: ProfileSelectionItem) => void;
  onClose?: () => void;
}

@Component({
  selector: "lkt-profile-selection-modal",
  standalone: true,
  imports: [LktIconComponent],
  templateUrl: "./profile-selection-modal.component.html",
  styleUrls: ["./profile-selection-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LktProfileSelectionModalComponent {
  public closeModalEvent = output<void>();
  public profileSelectedEvent = output<ProfileSelectionItem>();

  private readonly modalRef = inject(NzModalRef);
  private readonly modalData = inject<ProfileSelectionModalData>(NZ_MODAL_DATA);

  public readonly profiles = signal<ProfileSelectionItem[]>(this.modalData.profiles);
  public readonly title = signal<string>(this.modalData.title ?? "Seleção de perfil");
  public readonly closeLabel = signal<string>(this.modalData.closeLabel ?? "Fechar");
  public readonly loading = signal<boolean>(false);

  public setLoading(value: boolean): void {
    this.loading.set(value);
  }

  public closeModal(): void {
    if (this.loading()) return;
    this.closeModalEvent.emit();
    if (this.modalData.onClose) {
      this.modalData.onClose();
    }
    this.modalRef.close();
  }

  public selectProfile(profile: ProfileSelectionItem): void {
    if (this.loading()) return;
    if (profile.isCurrent) {
      this.closeModal();
      return;
    }
    this.profileSelectedEvent.emit(profile);
    if (this.modalData.onProfileSelected) {
      this.modalData.onProfileSelected(profile);
    }
  }
}
